<template>
  <div class="container mt-lg-5 mb-5">
    <div class="d-flex flex-row">
      <div class="d-flex flex-row align-items-center justify-content-center gap-2">
        <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('volver') }}</span>
        </router-link>
        <h2 class="m-0">{{ $t('grupo') }}</h2>
        <button @click="isEditing = true" v-if="!isEditing" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>
        <button class="btn p-2 d-none d-md-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click.stop="deleteGrupo()">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
            <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('eliminar') }}</span>
        </button>
      </div>
      <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
        <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
      </div>
    </div>
    <div>
      <form @submit.prevent="saveChanges" class="d-flex flex-column gap-2">
        <p class="m-0 fs-7 w-100"><strong>{{ $t('nombreGrupo') }}:</strong> <input type="text" v-model="grupo.Nombre" class="form-control sombra-sm" maxlength="100" required :disabled="!isEditing" /></p>

        <!-- Listas -->
        <div class="d-flex flex-column w-100 gap-2">
          <!-- Mostrar listas actuales -->
          <p class="fs-7 m-0"><strong>{{ $t('listas') }}:</strong></p>
          
          <div v-for="(lista, index) in grupo.Listas" :key="lista.IdLista" class="d-flex flex-column w-100 border-0 fondo-secundario sombra-sm rounded">
            <!-- Mostrar el nombre del evaluador o 'submit' si no existe -->
            <div class="d-flex flex-row gap-2 w-100 px-3 border border-0 fondo-secundario sombra-sm rounded justify-content-between align-items-center" style="min-height: 50px; cursor: pointer;" @click="lista.showValues = !lista.showValues">
              <div v-if="!isEditing" class="d-flex flex-column align-items-start">
                  <span class="">{{ lista.Nombre }}</span>
                  <span class="fs-7 m-0" v-if="lista.PersonaResponsable"><strong>{{$t('responsable')}}:</strong> &nbsp;{{ (lista.PersonaResponsable?.Apellido + " " + lista.PersonaResponsable?.Nombre) }}</span>
              </div>
              <div v-else class="d-flex flex-row gap-2 align-items-center">
                  <span class="d-flex gap-1 align-items-center" @click.stop><strong>{{ $t('nombreLista') }}:</strong><input type="text" v-model="lista.Nombre" class="form-control" maxlength="50" required/></span>
                  <div class="d-flex flex-row gap-2 align-items-center position-relative" @click.stop>
                    <input type="text" v-model="lista.SearchQuery" :placeholder="$t('buscarPersona') + '...'" class="form-control w-100" @input="filterPersonas(lista)" />
                    <ul v-if="lista.FilteredPersonas.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%; top: 100%;">
                      <li v-for="evaluado in lista.FilteredPersonas" :key="evaluado?.IdPersona" class="list-group-item list-group-item-action text-start fondo-terciario texto-principal borde-secundario" @click="selectPersona(evaluado, lista)" style="cursor: pointer;">
                        {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                      </li>
                    </ul>
                  </div>
                  <button type="button" @click="removeGrupo(index)" class="btn btn-danger btn-sm ms-2">{{ $t('eliminar') }}</button>
              </div>

              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: lista.showValues ? 'scaleY(1)' : 'scaleY(-1)' }">
                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
              </svg>
            </div>


            <!-- Mostrar los valores solo si showValues es true -->
            <div v-if="lista.showValues">
              <!-- Mostrar los valores agrupados -->
              <div v-if="lista.PersonasRelacionadas" class="d-flex flex-column p-2 px-3">
                <span class="fs-7 m-0"><strong>{{$t('personasRelacionadas')}}:</strong></span>
                <div v-for="(persRel, indexPersona) in lista.PersonasRelacionadas" :key="persRel.IdPersona" class="d-flex flex-row justify-content-start w-100 py-1">
                  <span class="fs-7 m-0 ms-2">-{{ (persRel.Persona?.Apellido + " " + persRel.Persona?.Nombre) }}</span>
                  <button v-if="isEditing" type="button" @click="removePersona(index, indexPersona)" class="btn btn-danger btn-sm ms-2">{{ $t('eliminar') }}</button>
                </div>
                <button v-if="isEditing && !addPersonaRelacionada" type="button" class="btn btn-primary mt-2" @click="addPersonaRelacionada = true">{{ $t('agregarPersona') }}</button>
                <div v-if="isEditing && addPersonaRelacionada" class="d-flex flex-row gap-2 align-items-center position-relative" @click.stop>
                  <input type="text" v-model="lista.SearchQueryRelacionada" :placeholder="$t('buscarPersona') + '...'" class="form-control w-100" @input="filterPersonasRelacionada(lista)" />
                  <ul v-if="lista.FilteredPersonasRelacionada.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%; top: 100%;">
                    <li v-for="evaluado in lista.FilteredPersonasRelacionada" :key="evaluado?.IdPersona" class="list-group-item list-group-item-action text-start fondo-terciario texto-principal borde-secundario" @click="selectPersonaRelacionada(evaluado, lista)" style="cursor: pointer;">
                      {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                    </li>
                  </ul>
                  <button type="button" class="btn btn-primary fs-6" @click="agregarPersonaRelacionada(lista)">
                    {{ $t('agregar') }}
                  </button>
                  <button type="button" class="btn btn-secondary fs-6" @click="addPersonaRelacionada = false">
                    {{ $t('cancelar') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-primary mt-2" @click="addLista" v-if="isEditing">{{ $t('agregarLista') }}</button>
        </div>
        <div class="d-flex flex-row gap-2">
          <button class="btn btn-success mt-3" type="submit" v-if="isEditing">{{ $t('guardar') }}</button>
          <button class="btn btn-secondary mt-3" @click="isEditing = false" v-if="isEditing">{{ $t('cancelar') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted} from 'vue';
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'EditarRoles',
  setup() {
    const { t } = useI18n();
    var isEditing = ref(false);
    var loading = ref(false);
    var addPersonaRelacionada = ref(false);
    //var loadingPermiso = ref(false);
    const router = useRouter();
    //const user = computed(() => store.state.user);
    const grupo = ref({});
    const allPersonas = ref({});
    var selectedPermiso = ref({});
    const empleados = ref([]);

    const fetchPersonas = async () => {
      try {
        const response2 = await api.get(`api/Persona/ByRole?role=Empleado`);
        empleados.value = response2.data;
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const fetchGrupo = async () => {
      try {
        loading.value = true;
        const idRol = localStorage.getItem('id');
        const response = await api.get(`api/Grupos/`+idRol);
        grupo.value = response.data;
        grupo.value.Listas = grupo.value.Listas.sort((a, b) => a.Nombre.localeCompare(b.Nombre))

        // Ordenar las PersonasListas dentro de cada opción por Apellido de Persona
        grupo.value.Listas.forEach(lista => {
          if (Array.isArray(lista.PersonasRelacionadas)) {
            lista.PersonasRelacionadas.sort((a, b) =>
              a.Persona?.Apellido?.localeCompare(b.Persona?.Apellido)
            );
          }
          else{
            lista.PersonasRelacionadas = [];
          }
          if (lista.PersonaResponsable) {
            lista.SearchQuery = `${lista.PersonaResponsable.Apellido} ${lista.PersonaResponsable.Nombre}`;
          } else {
            lista.SearchQuery = '';
          }
          lista.FilteredPersonas ??= [];
          lista.PersonaResponsable ??= {};
          lista.FilteredPersonasRelacionada ??= [];
          lista.PersonaResponsableRelacionada ??= {};
        });


        console.log(grupo.value)
        loading.value = false;
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = (lista) => {
      if (!lista.SearchQuery) {
        lista.FilteredPersonas = [];
      } else {
        const query = lista.SearchQuery.toLowerCase();
        lista.FilteredPersonas = empleados.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersona = (evaluado, lista) => {
      lista.PersonaResponsable = evaluado; // Asigna la persona seleccionada
      lista.IdResponsable = evaluado.IdPersona
      lista.SearchQuery = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      lista.FilteredPersonas = []; // Limpia la lista filtrada
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonasRelacionada = (lista) => {
      if (!lista.SearchQueryRelacionada) {
        lista.FilteredPersonasRelacionada = [];
      } else {
        const query = lista.SearchQueryRelacionada.toLowerCase();
        lista.FilteredPersonasRelacionada = empleados.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersonaRelacionada = (evaluado, lista) => {
      lista.PersonaResponsableRelacionada = evaluado; // Asigna la persona seleccionada
      lista.SearchQueryRelacionada = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      lista.FilteredPersonasRelacionada = []; // Limpia la lista filtrada
    };

    const agregarPersonaRelacionada = (lista) => {
      const persona1 = empleados.value.find(
        (p) => `${p.Apellido} ${p.Nombre}` === lista.SearchQueryRelacionada
      );
      if (!persona1) {
        alert("No se encontro a la persona")
        return; // Si no hay persona, salir
      }

      // Verificar que no esté ya en los autorizadores
      const yaExiste = lista.PersonasRelacionadas.some(a => a.IdPersona === persona1.IdPersona);
      if (!yaExiste) {
        if (lista.PersonaResponsable.IdPersona == persona1.IdPersona) {
          alert("La persona no se puede agregar porque ya es responsable de la lista.")
        }else{
          lista.PersonasRelacionadas.push({
            IdLista: lista.IdLista || '00000000-0000-0000-0000-000000000000',
            IdPersona: persona1.IdPersona,
            Persona: persona1,
          });
        }
      }else{
        alert("La persona ya esta")
      }


      lista.SearchQueryRelacionada = ''
      lista.FilteredPersonasRelacionada = []
    };

    const addLista = () => {
      grupo.value.Listas.push({
        IdLista: '00000000-0000-0000-0000-000000000000',
        IdGrupoDeListas: grupo.value.IdGrupoDeListas,
        Nombre: '',
        PersonaResponsable: {},
        PersonasRelacionadas: [],
        SearchQuery: '',
        FilteredPersonas: [],
        SearchQueryRelacionada: '',
        FilteredPersonasRelacionada: [],
      });
    }

    const saveChanges = async () => {
      try {
        console.log(grupo.value)


        const payloadLimpio = createGrupoPayload(grupo.value);
        console.log(payloadLimpio)

        await api.put(`api/Grupos/`+grupo.value.IdGrupoDeListas, payloadLimpio);
        isEditing.value = false;
      } catch (error) {
        console.error('Error al guardar los cambios:', error);
        alert('Hubo un problema al guardar los datos.');
      }
    };

    function createGrupoPayload(grupoFromState) {
      // 1. Mapea el objeto principal (GrupoDTO)
      const payload = {
        IdGrupoDeListas: grupoFromState.IdGrupoDeListas,
        Nombre: grupoFromState.Nombre,
        // 2. Mapea la colección de Listas usando .map()
        Listas: grupoFromState.Listas.map(lista => {
          
          // 3. Dentro de cada opción, mapea la sub-colección de PersonasRelacionadas
          const personasRelacionadasPayload = lista.PersonasRelacionadas.map(persona => {
            // Solo nos interesa el IdPersona para la relación
            return {
              IdPersona: persona.IdPersona
            };
          });

          // 4. Construye el objeto ListaDTO limpio
          return {
            IdLista: lista.IdLista,
            IdGrupoDeListas: lista.IdGrupoDeListas,
            Nombre: lista.Nombre,
            // LÓGICA CLAVE: Si IdResponsable es un string vacío, o undefined, manda null.
            IdResponsable: lista.IdResponsable || null, 
            PersonasRelacionadas: personasRelacionadasPayload
          };
        })
      };

      return payload;
    }

    const deleteGrupo = async () => {
      try {
        loading.value = true;
        console.log(grupo.value)
        await api.delete(`api/Grupos/`+grupo.value.IdGrupoDeListas);
        isEditing.value = false;
        await router.push('/personas/verGrupos');
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.error('Error al guardar los cambios:', error);
        alert('Hubo un problema al guardar los datos.');
      }
    };

    const removeGrupo = (index) => {
      // Eliminar la nacionalidad en el índice dado
      grupo.value.Listas.splice(index, 1);
    };

    const removePersona = (index, indexPersona) => {
      // Eliminar la nacionalidad en el índice dado
      grupo.value.Listas[index].PersonasRelacionadas.splice(indexPersona, 1);
      console.log('prueba')
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      fetchGrupo();
      fetchPersonas();
    });

    return {
      t,
      grupo,
      isEditing,
      loading,
      saveChanges,
      allPersonas,
      selectedPermiso,
      removeGrupo,
      removePersona,
      addLista,
      selectPersona,
      filterPersonas,
      selectPersonaRelacionada,
      filterPersonasRelacionada,
      addPersonaRelacionada,
      agregarPersonaRelacionada,
      deleteGrupo
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
</style>
